<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Perfiles de usuario</h4>
    <hr />

    <DataTable
      :data="perfils"
      :columns="columnas"
      idField="idPerfil"
      mensajeVacio="No hay perfiles registrados."
      :mostrarBotonNuevo="true"
      :mostrarEditar="true"
      :mostrarVer="true"
      :mostrarEliminar="true"
      @refresh="getData"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idPerfil)"
      @view="row => abrirEditar(row.idPerfil)"
      @delete="row => deletePerfil(row.idPerfil)"
    >
      <!-- Búsqueda por nombre -->
      <template #acciones-extra>
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            placeholder="Buscar perfil..."
            style="width:220px; text-transform:uppercase"
            @keyup.enter="getDataNombre"
          />
          <button
            class="btn btn-outline-primary btn-sm"
            @click="getDataNombre"
            title="Buscar"
          >
            <span class="material-icons" style="font-size:16px">search</span>
          </button>
        </div>
      </template>
    </DataTable>

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">

              <!-- ID solo en edición -->
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-3"><label class="form-label fw-bold">ID</label></div>
                  <div class="col-9">
                    <input type="text" class="form-control" v-model="datoPerfil.idPerfil" disabled />
                  </div>
                </div>
              </div>

              <!-- Campos del perfil generados desde la lista -->
              <div class="mb-3" v-for="campo in camposFormulario" :key="campo.field">
                <div class="row">
                  <div class="col-3">
                    <label class="form-label fw-bold">{{ campo.label }}</label>
                  </div>
                  <div class="col-9">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoPerfil[campo.field]"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>

            </div>
          </form>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarPerfil"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarPerfil"
              v-if="btnEditar"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

// Definición centralizada de los campos del perfil
// Se reutiliza en el formulario modal y en la validación
const CAMPOS_PERFIL = [
  { field: "nombre",               label: "Nombre"                },
  { field: "moduloAdministracion", label: "Módulo Administración" },
  { field: "moduloAtencion",       label: "Módulo Atención"       },
  { field: "moduloFacturacion",    label: "Módulo Facturación"    },
  { field: "moduloDashboards",     label: "Módulo Dashboards"     },
  { field: "menuParametros",       label: "Menú Parámetros"       },
  { field: "menuProcesos",         label: "Menú Procesos"         },
  { field: "menuReportes",         label: "Menú Reportes"         },
  { field: "menuAyuda",            label: "Menú Ayuda"            },
  { field: "opcionConsulta",       label: "Opción Consulta"       },
  { field: "opcionOperaciones",    label: "Opción Operaciones"    },
  { field: "opcionDescarga",       label: "Opción Descarga"       },
  { field: "opcionMenu",           label: "Opción Menú"           },
];

export default {
  name: "PerfilList",
  components: { Layout, Footer, DataTable },

  data() {
    return {
      perfils:        [],
      datoPerfil:     {},
      nombreBusqueda: "",
      titulo:         "",
      btnCrear:       false,
      btnEditar:      false,
      modalWindow:    true,
    };
  },

  computed: {
    // Columnas visibles en la tabla
    columnas() {
      return [
        { label: "Nombre",               field: "nombre"               },
        { label: "Módulo Administración", field: "moduloAdministracion" },
        { label: "Módulo Atención",       field: "moduloAtencion"       },
        { label: "Módulo Facturación",    field: "moduloFacturacion"    },
      ];
    },

    // Campos del formulario modal (todos)
    camposFormulario() {
      return CAMPOS_PERFIL;
    },
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.getData();
  },

  methods: {
    // ── Carga de datos ────────────────────────────────────────
    getData() {
      this.nombreBusqueda = "";
      api.get("/vwperfils")
        .then(r => { this.perfils = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar perfiles:", e));
    },

    getDataNombre() {
      const nombre = this.nombreBusqueda.trim();
      if (!nombre) { this.getData(); return; }
      api.get("/vwperfils/nombre/" + nombre)
        .then(r => { this.perfils = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al buscar perfil:", e));
    },

    // ── Validación ────────────────────────────────────────────
    validarForm() {
      const fields = CAMPOS_PERFIL.map(c => c.field);
      const labels = CAMPOS_PERFIL.map(c => c.label);
      return validarForm(this.datoPerfil, fields, labels);
    },

    // ── CRUD ──────────────────────────────────────────────────
    async guardarPerfil() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/perfils", this.datoPerfil);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Perfil creado exitosamente." });
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },

    async actualizarPerfil() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/perfils", this.datoPerfil);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Perfil actualizado exitosamente." });
        this.getData();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },

    async deletePerfil(idPerfil) {
      const confirm = await Swal.fire({
        title:             "¿Eliminar perfil?",
        text:              "Esta acción no se puede deshacer.",
        icon:              "warning",
        showCancelButton:  true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText:  "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/perfils/" + idPerfil);
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },

    // ── Modales ───────────────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoPerfil  = {};
      this.titulo      = "Crear Perfil de usuario";
      this.btnCrear    = true;
      this.btnEditar   = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    async abrirModalEditar(idPerfil) {
      this.modalWindow = true;
      this.titulo      = "Editar Perfil de usuario";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp      = await api.get("/vwperfils/" + idPerfil);
        this.datoPerfil = resp.data;
      } catch (e) {
        console.error("Error al cargar perfil:", e);
        return;
      }
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    abrirEditar(idPerfil) {
      if (idPerfil != null) this.$router.push("/perfilmd/" + idPerfil);
    },
  },
};
</script>